import { defineMessages } from "react-intl";
export const messages = defineMessages({
    prospectStatusSelectorLabel: {
        id: "analytisc.prospectStatus.selector.label",
        defaultMessage: "Prospect Status",
    },
});
